import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../../../../components/appbar"
import Footer from "../../../../components/footer";
import "./klostersstyle.css"
import React from "react";




export default function Klosterspage(){

    let navigate = useNavigate();    

    



    return(
        <div>
            <ResponsiveAppBar/>
            <br></br>
            <div className="info">
                <h1>WLAN Zugänge Klosters</h1>
            </div>

            <div className="wlanbox">
                <h2>ItHurtsWhenIP2.4 (2.4 Ghz) - WLAN Login</h2>
                <br></br>
            <p><strong>Network:</strong> ItHurtsWhenIP2.4</p>
            <br></br>
            <p><strong>Passwort:</strong> Diavolezza</p>
            
            </div>
           
            <div className="wlanbox">

            <h2> Gastnetzwerk - SwissGuest </h2>
            <br></br>
            <p><strong>Network:</strong> SwissGuest</p>
            <br></br>
            <p><strong>Passwort:</strong> Weissfluhjoch2693</p>
            <br></br>
        
            <a href="http://connect.acer">
            <Button>WLAN Admin</Button>
            </a>
            <br></br>
            <br></br>
            </div>
        

        <Footer/>
        </div>
    );
}

